import styled, { css } from "styled-components";

export const UserProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  max-width: ${({ theme }) => theme.width.widthMain};
  margin: auto;
  padding: 1rem 2rem;
`;

export const Navigation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 300px; /* Adjust the maximum width as needed */
  padding: 1rem;
  background-color: #f5f5f5;
  border-right: 1px solid #ddd;

  ul {
    list-style: none;
    padding: 0;

    li {
      padding: 0.5rem 0;
      cursor: pointer;
      font-size: 1.3rem;
      &:hover {
        background-color: #e0e0e0;
      }
    }
  }
`;

export const ProfileDetails = styled.div`
  width: 100%;
  max-width: 300px; /* Adjust the maximum width as needed */
  padding: 1rem;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }

  p {
    margin: 0.5rem 0;
    font-size: 1.4rem;
  }

  button {
    width: 100%;
    background-color: #000000;
    color: #fff;
    border: none;
    padding: 0.5rem 1rem;
    cursor: pointer;
    transition: background-color 0.3s;
    text-align: center;
    font-size: 1.6rem;

    &:hover {
      background-color: #0056b3;
    }
  }
`;
